import { createFileRoute } from '@tanstack/react-router';

import { CompanyAiProviderPage } from '../features/manage/company-ai-provider-page';

export const Route = createFileRoute('/manage/$companySlug/settings/ai-provider')({
  component: RouteComponent,
});

function RouteComponent() {
  const { companySlug } = Route.useParams();
  return <CompanyAiProviderPage companySlug={companySlug} />;
}
